export enum AccountBillingType {
    CREDIT = 'CREDIT',
    INVOICE = 'INVOICE',
}

// tslint:disable:no-namespace
export namespace AccountBillingType {
    export function fromString(str: string): AccountBillingType {
        switch (str.toUpperCase()) {
            case 'CREDIT':
                return AccountBillingType.CREDIT
            case 'INVOICE':
            default:
                return AccountBillingType.INVOICE
        }
    }
}
